import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { darken, lighten, fade } from '@material-ui/core/styles/colorManipulator';
import red from '@material-ui/core/colors/red';
import grey from '@material-ui/core/colors/grey';
import DropdownIndicatorIcon from '../form/input/MultiSelect/DropdownIndicatorIcon';
export var colorIntentionKeys = {
  primary: true,
  secondary: true,
  error: true,
  inherit: true,
  action: true
};
export var colorIntentions = Object.keys(colorIntentionKeys);
var NAVBAR_HEIGHT = 50;
var TOOLBAR_HEIGHT = 48;
var PRIMARY_ORANGE_COLOR = '#FF6633';
var HOVER_ORANGE_COLOR = '#FF9933';
var DIVIDER_COLOR = 'rgba(0, 0, 0, 0.12)'; //theme.palette.divider

var PRIMARY_DARK_GREY = '#4A5662';
var PRIMARY_TEXT_COLOR = '#000000';
var PRIMARY_BLUE_COLOR = '#337ab7';
var SECONDARY_BLUE_COLOR = '#289fcb';
var NAVBAR_COLOR = '#FFFFFF';
var NAVBAR_TEXT_COLOR = '#000000';
var SPACING_UNIT = 8;
var SHAPE_BORDER_RADIUS = 2;
var GREY_HOVER_COLOR = '#F3F5F7';
var GREY_ACTIVE_COLOR = '#E0E5EB';
var z1Shadow = {
  boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px;'
};
/**
 * @type {import('./types').PartialEcrionTheme}
 */

export var defaultTheme = {
  /** Theme variant */
  variant: 'default',
  spacing: SPACING_UNIT,

  /** Ecrion theme settings are grouped under common and configures the internal components */
  common: {
    interaction: {
      fill: {
        backgroundColor: PRIMARY_ORANGE_COLOR,
        textColor: '#fff'
      },
      text: {
        textColor: PRIMARY_ORANGE_COLOR,
        darkTextColor: darken(PRIMARY_ORANGE_COLOR, 0.2)
      }
    },

    /** Used by formatter (job progress, switch), */
    intention: {
      running: GREY_ACTIVE_COLOR,
      error: red[400],
      success: '#479b47',
      warning: '#E7AE59'
    },
    background: {
      //Obsolete

      /** body background */
      default: '#eee',
      defaultContent: '#ddd',
      defaultSidebar: '#eee'
    },
    divider: {
      color: grey[300],
      darkColor: darken(grey[300], 0.4),
      darkerColor: darken(grey[300], 0.85)
    },

    /**
     * Sidebar settings; Obsolete
     */
    sidebar: {
      width: 250,
      collapsedWidth: 42,
      backgroundColor: '#d6d6d6',
      selectedColor: 'rgba(255, 255, 255, 0.65)'
    },

    /** Properties panel settings; Obsolete */
    properties: {
      width: 320,
      collapsedWidth: 42,
      pin: {
        width: 42,
        height: 32
      }
    },
    Page: {
      /** Navigation bar on the top of the screen. */
      NavBar: {
        style: {
          height: NAVBAR_HEIGHT,
          backgroundColor: NAVBAR_COLOR,
          color: NAVBAR_TEXT_COLOR,
          boxShadow: '0px 0px 6px 3px rgba(0, 0, 0, 0.1)',
          activeBackground: GREY_ACTIVE_COLOR,
          hoverBackground: GREY_HOVER_COLOR
        },
        props: {}
      },

      /** Configure contextual toolbar positioned under the navbar. */
      ToolBar: {
        style: {
          /** Height of the contextual toolbar. */
          height: TOOLBAR_HEIGHT,

          /** The color of the contextual toolbar.
           * Dark, light and contrast colors are inferred based on the value you provide. */
          backgroundColor: NAVBAR_COLOR,
          color: NAVBAR_TEXT_COLOR,
          boxShadow: '0px 0px 6px 3px rgba(0, 0, 0, 0.1)'
        }
      },
      Common: {
        style: {
          backgroundColor: '#eee'
        }
      },
      SideBar: {
        style: {
          backgroundColor: '#d6d6d6',
          filterWidth: 250,
          propertyWidth: 320,
          propertiesWidth: 250,
          collapsedWidth: 42
        }
      }
    },
    Data: {
      Grid: {
        style: {
          selectionColor: GREY_ACTIVE_COLOR,
          contextMenuOpenedColor: GREY_ACTIVE_COLOR,
          selectorColor: PRIMARY_DARK_GREY,
          selectorItemColor: PRIMARY_BLUE_COLOR,
          hoverColorBackground: GREY_HOVER_COLOR
        }
      }
    },
    Formatter: {
      Link: {
        props: {}
      }
    },
    Form: {
      Fragment: {
        props: {}
      },
      Input: {
        Text: {
          props: {}
        },
        Checkbox: {
          props: {}
        },
        MultiSelect: {
          style: {
            optionFocusedBackgroundColor: fade(GREY_ACTIVE_COLOR, 0.2)
          }
        },
        ColorButton: {
          props: {}
        }
      }
    }
  },

  /** MUI specific */
  palette: {
    error: red,
    primary: {
      light: GREY_HOVER_COLOR,
      main: GREY_ACTIVE_COLOR,
      dark: darken(GREY_ACTIVE_COLOR, 0.2),
      contrastText: '#fff'
    },
    secondary: {
      light: GREY_HOVER_COLOR,
      main: GREY_ACTIVE_COLOR,
      dark: darken(GREY_ACTIVE_COLOR, 0.2),
      contrastText: '#fff'
    },
    action: {
      active: grey[800],
      disabled: 'inherit',
      selected: 'rgba(255, 255, 255, 0.6)',
      hover: 'rgba(255, 255, 255, 0.85)'
    },
    text: {
      hint: 'rgba(0, 0, 0, 0.48)'
    }
  },
  typography: {
    fontFamily: '"Lato", sans-serif',
    h6: {
      fontSize: '1.09rem',
      fontWeight: 400,
      marginTop: '0.25rem',
      marginBottom: '0.35rem'
    },
    h5: {
      fontSize: '1.41rem',
      fontWeight: 600
    },
    h4: {
      fontSize: '1.75rem'
    },
    subtitle1: {
      fontSize: '0.925rem',
      fontWeight: 600,
      marginBottom: '0.25rem'
    }
  },
  shape: {
    borderRadius: SHAPE_BORDER_RADIUS
  },
  props: {
    MuiTypography: {
      variant: 'body2',
      display: 'block'
    },
    MuiTableCell: {
      size: 'small'
    },
    MuiButtonBase: {
      disableRipple: false,
      focusRipple: true,
      disableTouchRipple: true
    },
    MuiInputLabel: {
      shrink: true
    },
    MuiSelect: {
      IconComponent: DropdownIndicatorIcon
    }
  },
  overrides: {
    MuiTypography: {
      body1: {
        color: PRIMARY_TEXT_COLOR
      },
      body2: {
        color: PRIMARY_TEXT_COLOR,
        lineHeight: 1.5
      },
      displayBlock: {
        color: PRIMARY_TEXT_COLOR
      },
      colorPrimary: {
        color: PRIMARY_BLUE_COLOR,
        '&:hover': {
          color: SECONDARY_BLUE_COLOR
        }
      }
    },
    MuiAppBar: {
      colorPrimary: {
        position: 'relative',
        boxShadow: '0px 0px 6px 3px rgb(0 0 0 / 10%)'
      }
    },
    MuiSelect: {
      icon: {
        color: 'rgba(0, 0, 0, 0.54)'
      },
      select: {
        paddingRight: SPACING_UNIT * 4
      }
    },
    MuiIconButton: {
      root: {
        borderRadius: SHAPE_BORDER_RADIUS,
        '&:hover': {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiSwitch: {
      colorSecondary: {
        color: 'white',
        '&$checked': {
          color: '#1666ab',
          '& + $track': {
            backgroundColor: '#1666ab'
          }
        }
      },
      colorPrimary: {
        color: 'white',
        '&$checked': {
          color: '#1666ab',
          '& + $track': {
            backgroundColor: '#1666ab'
          }
        }
      },
      switchBase: {
        height: 18
      },
      thumb: {
        width: 15,
        height: 15
      },
      track: {
        width: 28,
        height: 10,
        marginTop: -5,
        marginLeft: -14
      }
    },
    MuiMenu: {
      paper: {
        minWidth: 150
      }
    },
    MuiDialog: {
      paper: {
        background: '#fafafa'
      }
    },
    MuiDialogContent: {
      root: {
        padding: '0 24px 24px'
      }
    },
    MuiGrid: {
      root: {
        color: PRIMARY_TEXT_COLOR
      }
    },
    MuiTableRow: {
      root: {
        height: SPACING_UNIT * 6,
        '&:last-child td': {
          border: 'none'
        }
      },
      head: {
        height: SPACING_UNIT * 7
      }
    },
    MuiTableCell: {
      stickyHeader: {
        backgroundColor: '#FFF'
      },
      sizeSmall: {
        padding: '0.5em 0.5em',
        paddingTop: 0,
        paddingBottom: 0,
        lineHeight: '1.42857143',
        '&:first-of-type': {
          paddingLeft: 12
        }
      },
      head: {
        color: 'inherit',
        fontWeight: 400,
        fontSize: '.9rem'
      }
    },
    MuiToolbar: {
      root: {
        minHeight: TOOLBAR_HEIGHT,
        '@media (min-width:600px)': {
          minHeight: TOOLBAR_HEIGHT
        },
        '@media (min-width:0px) and (orientation: landscape)': {
          minHeight: TOOLBAR_HEIGHT
        }
      }
    },
    MuiListItem: {
      button: {
        transition: 'none'
      }
    },
    MuiListItemText: {
      root: {
        marginTop: 0,
        marginBottom: 0,
        padding: '0px 16px'
      },
      dense: {
        paddingLeft: 0
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 'auto'
      }
    },
    MuiList: {
      root: {
        color: PRIMARY_TEXT_COLOR
      }
    },
    MuiMenuItem: {
      root: {
        color: PRIMARY_TEXT_COLOR,
        padding: "".concat(SPACING_UNIT / 2, "px ").concat(SPACING_UNIT * 2, "px"),
        fontSize: '.875rem',
        lineHeight: '1.42857143',
        '&:hover': {
          backgroundColor: GREY_HOVER_COLOR,
          color: '#000000'
        },
        '&:hover span': {
          color: 'black'
        },
        '&$selected': {
          backgroundColor: GREY_HOVER_COLOR,
          color: 'black',
          '&:hover, &:focus': {
            backgroundColor: GREY_HOVER_COLOR,
            color: 'black'
          },
          '&:hover span, &:focus span': {
            color: 'black'
          }
        }
      }
    },
    MuiDivider: {
      root: {
        marginTop: SPACING_UNIT,
        marginBottom: SPACING_UNIT
      }
    },
    MuiButtonBase: {
      root: {
        '&$disabled': {
          //dependent on the inherited color
          opacity: 0.4
        }
      }
    },
    MuiButton: {
      root: {
        paddingLeft: SPACING_UNIT * 1.5,
        paddingRight: SPACING_UNIT * 1.5,
        transitionDuration: '0s',
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      sizeSmall: {
        paddingLeft: SPACING_UNIT * 1.5,
        paddingRight: SPACING_UNIT * 1.5,
        minWidth: SPACING_UNIT * 8
      },
      label: {
        textTransform: 'capitalize'
      },
      outlined: {
        boxShadow: 'none',
        '&:focus': _objectSpread({}, z1Shadow),
        fontWeight: 400,
        padding: '6px 12px'
      },
      outlinedPrimary: {
        color: PRIMARY_ORANGE_COLOR,
        borderColor: PRIMARY_ORANGE_COLOR,
        '&:hover, &:focus': {
          borderColor: PRIMARY_ORANGE_COLOR
        }
      },
      outlinedSecondary: {
        color: PRIMARY_ORANGE_COLOR,
        borderColor: PRIMARY_ORANGE_COLOR,
        '&:hover, &:focus': {
          borderColor: PRIMARY_ORANGE_COLOR
        }
      },
      textPrimary: {
        color: PRIMARY_ORANGE_COLOR
      },
      contained: {
        '&:focus': _objectSpread({}, z1Shadow),
        fontWeight: 400,
        padding: '6px 12px'
      },
      containedPrimary: {
        backgroundColor: PRIMARY_ORANGE_COLOR,
        '&:active': {
          backgroundColor: PRIMARY_ORANGE_COLOR
        },
        '&:hover': {
          backgroundColor: HOVER_ORANGE_COLOR
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        color: 'inherit',
        '&$disabled': {
          color: 'inherit',
          opacity: 0.54
        }
      }
    },
    MuiCheckbox: {
      root: {
        color: '#627383',
        '&$checked': {
          opacity: 1
        },
        '&:hover': {
          color: '#4a5662'
        },
        '&.Mui-disabled': {
          color: '#caced4'
        },
        '&.Mui-focused': {
          color: '#4a5662'
        },
        "&.Mui-focused .MuiSvgIcon-root path": {
          outline: '2px solid #abd2f4'
        },
        "&.Mui-error": {
          color: "#f10000",
          '&:hover': {
            color: '#910000'
          }
        }
      },
      colorPrimary: {
        '&.Mui-checked': {
          color: "#1666ab"
        },
        '&.Mui-checked:hover': {
          color: "#0b3356"
        },
        '&.Mui-checked.Mui-disabled': {
          color: "#E0E5EB"
        },
        '&.Mui-disabled': {
          color: '#caced4'
        },
        '&.Mui-focused': {
          color: '#4a5662'
        },
        "&.Mui-focused .MuiSvgIcon-root path": {
          outline: '2px solid #abd2f4'
        },
        "&.Mui-error": {
          color: "#f10000",
          '&:hover': {
            color: '#910000'
          }
        }
      },
      colorSecondary: {
        '&.Mui-checked': {
          color: "#1666ab"
        },
        '&.Mui-checked:hover': {
          color: "#0b3356"
        },
        '&.Mui-checked.Mui-disabled': {
          color: "#E0E5EB"
        },
        '&.Mui-disabled': {
          color: '#caced4'
        },
        '&.Mui-focused': {
          color: '#4a5662'
        },
        "&.Mui-focused .MuiSvgIcon-root path": {
          outline: '2px solid #abd2f4'
        },
        "&.Mui-error": {
          color: "#f10000",
          '&:hover': {
            color: '#910000'
          }
        }
      }
    },
    MuiRadio: {
      root: {
        color: '#627383',
        '&$checked': {
          color: '#1666ab'
        },
        '&:hover': {
          color: '#4a5662'
        }
      },
      colorPrimary: {
        '&.Mui-checked': {
          color: "#1666ab"
        },
        '&.Mui-checked:hover': {
          color: "#0b3356"
        },
        "&.Mui-focused .MuiSvgIcon-root path": {
          outline: '2px solid #abd2f4'
        },
        '&.Mui-disabled': {
          color: '#caced4',
          opacity: 1
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: 'inherit',
        '&$disabled': {
          color: 'inherit',
          opacity: 0.54
        }
      }
    },
    MuiInputBase: {
      root: {
        color: 'inherit',
        '&$root$disabled:before': {
          borderBottomStyle: 'solid',
          borderBottomColor: 'rgba(0, 0, 0, 0.2)'
        }
      },
      input: {
        fontSize: '.875rem',
        height: 'inherit'
      },
      disabled: {}
    },
    MuiFormHelperText: {
      root: {
        '.ModalWindowContent &$error': {
          animationName: 'FormErrorModalFix',
          animationDuration: '400ms',
          animationFillMode: 'forwards'
        }
      }
    },
    MuiLink: {
      root: {
        '&:not([href]):hover': {
          textDecoration: 'none',
          cursor: 'pointer'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        color: grey[900],
        '&$disabled': {
          backgroundColor: 'inherit',
          color: 'inherit',
          opacity: 0.54
        },
        '&.Mui-focused': {
          borderColor: SECONDARY_BLUE_COLOR,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: SECONDARY_BLUE_COLOR
          }
        }
      },
      input: {
        padding: 8
      }
    },
    MuiFilledInput: {
      root: {
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        color: PRIMARY_TEXT_COLOR,
        border: "1px solid ".concat(DIVIDER_COLOR),
        '&$disabled': {
          backgroundColor: 'inherit',
          color: 'inherit',
          opacity: 0.54
        },
        '&$disabled&': {
          '@media (hover: none)': {
            backgroundColor: 'inherit',
            color: 'inherit',
            opacity: 0.54
          }
        },
        '&:hover': {
          backgroundColor: 'rgb(255, 255, 255)',
          border: "1px solid ".concat(fade(DIVIDER_COLOR, 0.2))
        },
        '&$focused': {
          backgroundColor: 'rgb(255, 255, 255)'
        },
        '@media (hover: none)': {
          '&&:hover': {
            backgroundColor: 'rgb(255, 255, 255)',
            color: PRIMARY_TEXT_COLOR
          }
        }
      },
      input: {
        paddingTop: 10
      },
      multiline: {
        paddingTop: 10
      },
      underline: {
        '&:before': {
          display: 'none'
        },
        '&:after': {
          bottom: -1,
          borderWidth: 3
        },
        '.ModalWindowContent &$error': {
          '&:after': {
            animationName: 'FormErrorModalFix',
            animationDuration: '400ms',
            animationFillMode: 'forwards',
            transitionDelay: '200ms'
          }
        }
      }
    },
    MuiInputLabel: {
      filled: {
        display: 'none' //filled inputs should always have a separate label

      }
    },
    MuiRating: {
      iconEmpty: {
        color: 'rgba(0, 0, 0, 0.26)'
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: PRIMARY_DARK_GREY,
        color: '#FFF',
        fontSize: '.875rem'
      }
    },
    MuiPickersClock: {
      clock: {
        zIndex: 'initial'
      },
      pin: {
        backgroundColor: PRIMARY_BLUE_COLOR
      }
    },
    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: PRIMARY_BLUE_COLOR
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: PRIMARY_BLUE_COLOR
      }
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: PRIMARY_BLUE_COLOR,
        borderRadius: "100%",
        '&:hover': {
          backgroundColor: PRIMARY_BLUE_COLOR
        }
      },
      current: {
        color: PRIMARY_BLUE_COLOR
      }
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: PRIMARY_BLUE_COLOR
      },
      thumb: {
        border: "14px solid ".concat(PRIMARY_BLUE_COLOR),
        backgroundColor: PRIMARY_BLUE_COLOR
      },
      noPoint: {
        backgroundColor: PRIMARY_BLUE_COLOR
      }
    },
    MuiTabs: {
      flexContainer: {
        color: "white"
      }
    },
    MuiPickersModal: {
      dialogRoot: {
        "& .MuiButton-root.MuiButton-textPrimary": {
          color: "white",
          backgroundColor: PRIMARY_BLUE_COLOR,
          borderRadius: "6px",
          '&:hover': {
            backgroundColor: darken(PRIMARY_BLUE_COLOR, 0.2)
          }
        }
      }
    },
    MuiFormGroup: {
      root: {
        '&.Mui-focused .MuiFormControlLabel-root .MuiRadio-colorPrimary.Mui-checked .MuiSvgIcon-root:nth-of-type(1) path': {
          outline: '2px solid #abd2f4',
          borderRadius: '100%'
        },
        '&.Mui-error .MuiFormControlLabel-root .MuiRadio-colorPrimary': {
          color: "#f10000",
          '&:hover': {
            color: '#910000'
          }
        }
      }
    }
  }
}; //@ts-ignore

export default createMuiTheme(defaultTheme);